import axios from "axios";

const apiURL = process.env.REACT_APP_BASE_URL;

const getFJGGAccessRequest = (query) => {
    let accessTokan = localStorage.getItem("auth");
    let url = `${apiURL}/FJGGAccess?source=ADMIN`;

    if (query) {
        url += `&search=${query}`;
    }

    return axios.get(url, {
        headers: {
            accept: "application/json",
            authorization: `bearer ${accessTokan}`,
        },
    });
};


  const grantFJGGAccessRequest = (data) => {
    let accessToken = localStorage.getItem("auth");
    return axios.post(`${apiURL}/confirm`,data,{
      headers: {
        accept: "application/json",
        authorization: `bearer ${accessToken}`,
      },
    });
  };

const checkFJGGAccessAndVersionsAvailableRequest = (data) => {
  let accessToken = localStorage.getItem("auth");
  return axios.get(`${apiURL}/checkFJGGAccessDetailsAndVersionsAvailable`, {
    params: data,
    headers: {
      accept: "application/json",
      authorization: `bearer ${accessToken}`,
    }
  });
}

export const fjggApis = {
  getFJGGAccessRequest,
  grantFJGGAccessRequest,
  checkFJGGAccessAndVersionsAvailableRequest,
};
